module.exports = __webpack_public_path__ + "asset/xiaowei_13i7DL5W.otf";